export class RequestsUseCaseCounterApi
{
    useCaseTypeId: number;
    useCaseTypeFR: string;
    useCaseTypeEN: string;
    count: number;
}
